import React, { useEffect, useState } from 'react';
import AdminLayout from './AdminLayout';
import api from '../../services/api';

export default function ShowDetails() {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    let mounted = true;
    api.get('/events').then(res => { if (mounted) setEvents(res.data); }).catch(err => console.error('Failed to load events', err));
    return () => { mounted = false; };
  }, []);

  return (
    <AdminLayout>
      <h2 className="text-xl font-bold mb-4">View Show Details</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {events.map(e => (
          <div key={e.id} className="bg-white p-4 rounded shadow">
            <h3 className="font-semibold text-lg">{e.name}</h3>
            <p>Date: {e.date}</p>
            <p>Status: {e.status}</p>
            <p>Capacity: {e.capacity}</p>
          </div>
        ))}
      </div>
    </AdminLayout>
  );
}
